<template>
  <div>
    <core-grid
      ref="grid"
      :onRead="onRead"
      :schema="schema"
      server-side
      :delete-option="false"
      :add-option="false"
      :edit-option="false"
      filter-option
      :grid-role="gridRole"
      :roles="{ add: addRole }"
    >
      <template v-slot:toolbar-prepend>
        <slot name="toolbar-prepend">
          <v-btn v-if="$param.HabilitaIncluirPropostaParceiro && userHasRole('IncluirPropostaGetContaParceiro')" color="primary" small class="pa-6 mr-2" fab @click="$emit('novo-parceiro')">
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
        </slot>
      </template>
      <template v-if="$param.HabilitaNovaProposta" v-slot:toolbar>
        <core-grid-button color="primary" @click="editar($event)" text="Novo" icon="fas fa-plus"></core-grid-button>
      </template>
      <template v-slot:toolbar-append>
        <core-grid-button v-if="$param.HabilitaExportarListaPropostas" @click="exportarRelatorio($event)" text="Exportar Lista de Propostas">
          <v-icon medium>fa fa-file-excel</v-icon>
        </core-grid-button>
        <core-grid-button v-if="$param.HabilitaExportarAnaliseMotor && $user.roles.includes('Multiplo.Master')" @click="relatorioMotor()" text="Exportar Análise Motor">
          <v-icon medium>fa fa-file</v-icon>
        </core-grid-button>
        <slot name="toolbar-extra"></slot>
      </template>
      <template slot="toolbar-append">
        <v-alert v-if="$param.HabilitaAlertaPendencias && possuiDocPendente" border="left" class="mb-0" dense text style="display: inline-grid; height: 100%" color="warning">
          <v-icon color="warning" class="mr-2">mdi-alert-outline</v-icon>Existem Propostas com pendências, <a @click="filtrarPendencias">clique aqui para filtrá-las</a>
        </v-alert>
      </template>
      <template v-slot:[`item.${campoCodigo}`]="{ item }">
        <slot name="coluna-codigo" :item="item">
          <div class="d-flex flex-column font-weight-medium my-4">
            <span>
              {{ '#' + item[campoCodigo] }}
            </span>
            <span class="text-caption">
              {{ $api.UI.Format.Date(item.DtInclusao, 'dd \'de\' MMMM \'de\' yyyy') }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:[`item.NrRevisao`]="{ item }">
        <slot name="coluna-nr-revisao" :item="item">
          <v-chip v-if="existeRevisao(item.NrRevisao)" x-small class="ma-2" color="red" text-color="white">
            {{ $api.UI.Format.LeftPadNumbers(item.NrRevisao, 3) }}
          </v-chip>
        </slot>
      </template>
      <template v-slot:[`item.NomeVendedor`]="{ item }">
        <slot name="coluna-vendedor" :item="item">
          <span class="d-flex flex-column font-weight-medium">
            {{ item.NomeVendedor }}
          </span>
        </slot>
      </template>
      <template v-slot:[`item.ClienteNome`]="{ item }">
        <slot name="coluna-cliente" :item="item">
          <div class="d-flex flex-column font-weight-medium my-4">
            <span>
              {{ item.ClienteNome }}
            </span>
            <span class="text-caption">
              {{ item.ClienteDocumentoFederal }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:[`item.VlrSolicitado`]="{ item }">
        <slot name="coluna-solicitado" :item="item">
          <div class="d-flex flex-column font-weight-medium my-4">
            <span>
              {{ $api.UI.Format.Currency(item.VlrSolicitado) }}
            </span>
            <span class="text-caption">
              {{ 'Em ' + item.QtdeParcelasSolicitado + ' parcela' + (item.QtdeParcelasSolicitado > 1 ? 's' : '') }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:[`item.VlrFinanciado`]="{ item }">
        <slot name="coluna-financiado" :item="item">
          <div class="d-flex flex-column font-weight-medium my-4">
            <span>
              {{ $api.UI.Format.Currency(item.VlrFinanciado) }}
            </span>
            <span class="text-caption">
              {{ item.QtdeParcelas ? ('Em ' + item.QtdeParcelas + ' parcela' + (item.QtdeParcelas > 1 ? 's' : '')) : '–' }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:[`item.${campoTipoContrato}`]="{ item }">
        <slot name="coluna-tipo-contrato" :item="item">
          <span>{{ item[campoTipoContrato] }}</span>
        </slot>
      </template>
      <template v-slot:[`item.Situacao`]="{ item }">
        <slot name="coluna-situacao" :item="item">
          <v-chip x-small outlined class="ma-2 px-2" color="warning" v-if="item.PendenteConferenciaEmpresa === true">
            Documentos Pendentes
          </v-chip>
          <v-chip x-small outlined class="ma-2 px-2" color="primary" v-else>
            {{ $aux.Situacao.find(p => p.value === item.Situacao).text }}
          </v-chip>
        </slot>
      </template>
      <template v-slot:[`item.Revisao`]="{ item }">
        <slot name="coluna-revisao-botao" :item="item">
          <v-btn
            @click="revisar($event, item)"
            x-small
            color="primary"
            v-if="userHasRole('FindRecordProposta') && ($param.HabilitaRevisarProposta || []).includes(item.Situacao)"
          >Revisão</v-btn>
        </slot>
      </template>
    </core-grid>
    <modal-filtro ref="filtrar" model="filtro" @refresh="refresh">
      <v-row>
        <v-col cols="6">
          <input-date v-if="!filtro.filtraPendencias" label="Incluído de" v-model="filtro.dataInicio"></input-date>
          <input-text prepend-inner-icon="event" v-else disabled label="Incluído de" :value="$api.UI.Format.Date(filtro.dataInicio)"></input-text>
        </v-col>
        <v-col cols="6">
          <input-date v-if="!filtro.filtraPendencias" label="Até" :min="filtro.dataInicio" v-model="filtro.dataTermino"></input-date>
          <input-text prepend-inner-icon="event" v-else disabled label="Até" :value="$api.UI.Format.Date(filtro.dataTermino)"></input-text>
        </v-col>
        <v-col cols="12">
          <input-select :options="$aux.Situacao" label="Situação" v-model="filtro.situacao"></input-select>
        </v-col>
        <v-col cols="12">
          <v-checkbox label="Filtrar propostas com pendências" v-model="filtro.filtraPendencias"></v-checkbox>
        </v-col>
        <v-col cols="12" class="py-0">
          <slot name="filtro-extra"></slot>
        </v-col>
      </v-row>
    </modal-filtro>
    <RelatorioMotorCredito v-if="$param.HabilitaExportarAnaliseMotor" ref="relatorio" />
  </div>
</template>
<script>
export default {
  components: {
    RelatorioMotorCredito: () => import('./RelatorioMotorCredito')
  },
  props: {
    campoCodigo: { type: String, default: 'CodigoCCB' },
    campoTipoContrato: { type: String, default: 'TipoContratoSigla' },
    extraSchema: { type: Array, default: () => [] },
    diasFiltroInicial: { type: Number, default: 28 },
    gridRole: { type: String, default: 'ListProposta' },
    addRole: { type: String, default: 'IncluirPropostaManual' },
    dtoExtra: { type: Function, default: null },
    condicaoEditarExtra: { type: Function, default: () => true },
    condicaoAlterarDadosBancariosExtra: { type: Function, default: () => true }
  },
  data () {
    return {
      possuiDocPendente: false,
      emailGerentes: '',
      emailMasters: '',
      filtro: {
        dataInicio: this.$api.UI.Format.Date(this.$api.UI.Date.AddDay(new Date(), -this.diasFiltroInicial), 'yyyy-MM-dd'),
        dataTermino: this.$api.UI.Format.Date(new Date(), 'yyyy-MM-dd')
      }
    }
  },
  computed: {
    schema () {
      const cols = [
        { text: '#', value: this.campoCodigo, width: '200' }
      ]
      if (this.$param.HabilitaNrRevisao) {
        cols.push({ text: 'Rev.', value: 'NrRevisao', align: 'center', width: '20' })
      }
      cols.push(
        { text: 'Vendedor', value: 'NomeVendedor' },
        { text: 'Cliente', value: 'ClienteNome' },
        { text: 'Solicitado', value: 'VlrSolicitado', width: '120' },
        { text: 'Aprovado', value: 'VlrFinanciado', width: '120' }
      )
      if (this.$param.HabilitaTipoContrato) {
        cols.push({ text: 'Tipo de Contrato', value: this.campoTipoContrato, width: '100' })
      }
      cols.push({ text: 'Situação', value: 'Situacao', align: 'center', width: '100' })
      if ((this.$param.HabilitaRevisarProposta || []).length > 0) {
        cols.push({ value: 'Revisao', width: '80' })
      }
      if ((this.$param.HabilitaAlterarDadosBancarios || []).length > 0) {
        cols.push({
          format: 'button',
          action: this.abrirRevisaoBancaria,
          icon: 'fas fa-university',
          tooltip: 'Alterar dados bancários',
          width: '20',
          condition: p => this.userHasRole('PropostaAtualizarContaPagamento') && (this.$param.HabilitaAlterarDadosBancarios || []).includes(p.Situacao) && this.condicaoAlterarDadosBancariosExtra(p)
        })
      }
      if ((this.$param.HabilitaEditarProposta || []).length > 0) {
        cols.push({
          format: 'button',
          action: this.editar,
          icon: 'fa-pencil-alt',
          tooltip: 'Editar',
          value: 'Editar',
          align: 'center',
          width: '20',
          condition: p => (this.$param.HabilitaEditarProposta || []).includes(p.Situacao) && this.condicaoEditarExtra(p)
        })
      }
      if ((this.$param.HabilitaFirmasPoderes || []).length > 0) {
        cols.push({
          format: 'button',
          action: this.abrirFirmasPoderes,
          icon: 'fas fa-file-signature',
          tooltip: 'Firmas e Poderes',
          value: 'Assinantes',
          align: 'center',
          width: '20',
          condition: p => (this.$param.HabilitaFirmasPoderes || []).includes(p.Situacao)
        })
      }
      cols.push(...this.extraSchema)
      if (this.$param.HabilitaAcoesProposta) {
        cols.push({ format: 'button', action: this.acoes, tooltip: 'Ações', icon: 'fas fa-list', value: 'Acoes', align: 'center', width: '20', condition: () => this.userHasRole('FindRecordProposta') })
      }
      return cols
    }
  },
  methods: {
    onRead (options, search) {
      const th = this
      const dto = {
        ...options,
        parameters: [
          { name: 'search', value: search },
          { name: 'DataInicio', value: th.filtro.dataInicio },
          { name: 'DataTermino', value: th.filtro.dataTermino },
          { name: 'Situacao', value: th.filtro.situacao },
          { name: 'FiltraPendenciasFormalizacao', value: th.filtro.filtraPendencias },
          { name: 'DocumentoParceiroCorrespondente', value: th.$empresa.documentoFederal },
          { name: 'DocumentoParceiroCorrespondenteLegado', value: th.$empresa.documentoFederalLegado }
        ]
      }
      if (th.$user.roles === 'Multiplo.Gerente') {
        dto.parameters.push({ name: 'FiltraGerente', value: true })
        dto.parameters.push({ name: 'EmailGerentes', values: th.emailGerentes })
        dto.parameters.push({ name: 'EmailMasters', values: th.emailMasters })
      } else if (th.$user.roles === 'Multiplo.Operador') {
        dto.parameters.push({ name: 'FiltraVendedor', value: true })
      }

      if (th.dtoExtra) th.dtoExtra(dto, th, 'onRead')

      if (th.$param.HabilitaAlertaPendencias) {
        th.$api.Multiplo.ExistePropostaPendente(dto).then(function (response) {
          th.possuiDocPendente = false
          if (th.$api.UI.PostLoadData(response)) {
            th.possuiDocPendente = response === true
          }
        })
      }

      th.$api.Multiplo.ListProposta(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          options.success(response.Data, response.Count)
        }
      })
    },
    existeRevisao (NrRevisao) {
      if (NrRevisao) return true
      return false
    },
    revisar (e, current) {
      e.preventDefault()
      this.$emit('revisar', current)
    },
    editar (e, current) {
      e.preventDefault()
      this.$emit('editar', current)
    },
    acoes (event, current) {
      event.preventDefault()
      if (current.PendenteConferenciaEmpresa === true) {
        this.$emit('pendencias', current)
      } else {
        this.$emit('acoes', current)
      }
    },
    abrirRevisaoBancaria (event, current) {
      event.preventDefault()
      if (current) {
        this.$emit('revisao-bancaria', current)
      }
    },
    abrirFirmasPoderes (e, current) {
      e.preventDefault()
      if (current) {
        this.$emit('firmas-poderes', current)
      }
    },
    filtrarPendencias () {
      this.$set(this.filtro, 'filtraPendencias', true)
      this.refresh()
    },
    relatorioMotor () {
      this.$refs.relatorio.openModal()
    },
    refresh () {
      this.$refs.grid && this.$refs.grid.refresh()
    },
    exportarRelatorio (e) {
      const th = this
      const dto = {
        parameters: [
          { name: 'DataInicio', value: th.filtro.dataInicio },
          { name: 'DataTermino', value: th.filtro.dataTermino },
          { name: 'Situacao', value: th.filtro.situacao },
          {
            name: 'DocumentoParceiroCorrespondente',
            value: th.$empresa.documentoFederal
          }
        ]
      }
      if (th.$param.HabilitaExportarCarregaTipoContrato) {
        dto.parameters.push({ name: 'CarregaTipoContrato', value: true })
      }
      if (th.$param.HabilitaFiltraPendenciasExportacao) {
        dto.parameters.push({ name: 'FiltraPendenciasFormalizacao', value: th.filtro.filtraPendencias })
      }
      if (th.dtoExtra) th.dtoExtra(dto, th, 'exportarRelatorio')
      th.$api.Exportacao.RelatorioCompleto(th, e, dto, th.$param.HabilitaExportarCustomFilter)
    }
  },
  mounted () {
    const th = this
    if (th.$user.roles === 'Multiplo.Gerente') {
      th.$api.Usuario.GetEmailGerentes().then(function (response) {
        th.emailGerentes = response.map(p => p.email)
        th.$api.Usuario.GetEmailMasters().then(function (response) {
          th.emailMasters = response.map(p => p.email)
          th.refresh()
        })
      })
    } else if (th.$user.roles === 'Multiplo.Master') {
      th.$api.Usuario.GetEmailMasters().then(function (response) {
        th.emailMasters = response.map(p => p.email)
        th.refresh()
      })
    } else {
      th.refresh()
    }
  }
}
</script>
